'use client'

import dynamic from 'next/dynamic'

import { RenderOnFirstInteraction } from '@/components/RenderOnFirstInteraction'

import type { TQrTypeCardProps } from '../../generator/components/QrTypeCard/QrTypeCardTypes'

const DynamicQrTypeCard = dynamic(() =>
	import('../../generator/components/QrTypeCard/QrTypeCard').then(
		(mod) => mod.QrTypeCard,
	),
)

export const LazyQrTypeCard = (props: TQrTypeCardProps) => (
	<RenderOnFirstInteraction element={<DynamicQrTypeCard {...props} />} />
)
